import { createHtmlDiff } from './utils/htmlAwareDiff';
import HtmlViewer from '@teetsh/app/src/components/HtmlViewer';

interface Props {
  originalText: string;
  newText: string;
  mode?: 'words' | 'chars';
}

function HtmlRenderingDiffView({
  originalText,
  newText,
  mode = 'words',
}: Props) {
  const diffHtml = createHtmlDiff(originalText, newText, mode);

  return <HtmlViewer text={diffHtml} onChange={() => {}} />;
}

export default HtmlRenderingDiffView;
